import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { RequiredFieldsLabel, RadioButtons } from '@grandvisionhq/forms';
import { Consents } from '../modules/Consents/layout/Consents.js';
import { Footer } from '../modules/Footer/Footer.js';
import { CustomerType } from '../types.js';
import { AddressesSectionContainer } from './components/AddressesSection/AddressesSectionContainer.js';
import { TitleWithIcon } from '../components/TitleWithIcon/TitleWithIcon.js';
import { ShippingMethods } from './modules/ShippingMethods/layouts/ShippingMethods.js';
import { CompanyFormContainer } from './containers/CompanyFormContainer.js';
import { ContactDetailsContainer } from './containers/ContactDetailsContainer.js';
import { InvoiceFormContainer } from './containers/InvoiceFormContainer.js';
import { ServiceStoreHeading } from '../modules/ServiceStore/layout/ServiceStoreHeading.js';
import { ServiceStore } from '../modules/ServiceStore/layout/ServiceStore.js';
import { ImplicitTermsAndConditionsContainer } from './containers/ImplicitTermsAndConditionsContainer.js';
import { StepNames } from '../models/shared.js';
import { ImplicitAccountCreationContainer } from './containers/ImplicitAccountCreationContainer.js';

const StepShipping = ({ company , isCompanyEnabled , isDelivery , isDeliveryExpress , labels , onNextStep , onPrevStep , routes , shippingMethodsAsides , showLoader , toggleDeliveryAddress , toggleIsCompany , handleOptInsLoading  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--shipping"
    }, showLoader && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--shipping__loader"
    }, /*#__PURE__*/ React.createElement(Loader, null)), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "orders",
        label: labels.shipmentMethodTitle
    }), /*#__PURE__*/ React.createElement(ShippingMethods, {
        shippingMethodsAsides: shippingMethodsAsides
    }), /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.generic.title
    }), /*#__PURE__*/ React.createElement(RequiredFieldsLabel, null), isCompanyEnabled && /*#__PURE__*/ React.createElement(RadioButtons, {
        scope: "orderType",
        alignment: "horizontal",
        onChange: toggleIsCompany,
        initialValue: company ? CustomerType.Company : CustomerType.Private,
        items: [
            {
                value: CustomerType.Private,
                label: labels.customerType.private
            },
            {
                value: CustomerType.Company,
                label: labels.customerType.company
            }, 
        ]
    }), /*#__PURE__*/ React.createElement(CompanyFormContainer, null), /*#__PURE__*/ React.createElement(AddressesSectionContainer, {
        isDelivery: isDelivery,
        isDeliveryExpress: isDeliveryExpress,
        onToggleDeliveryAddress: ({ checked  })=>toggleDeliveryAddress({
                checked: !checked
            })
    }), /*#__PURE__*/ React.createElement(ContactDetailsContainer, null), /*#__PURE__*/ React.createElement(InvoiceFormContainer, null), /*#__PURE__*/ React.createElement(ServiceStoreHeading, {
        hideIcon: false,
        title: labels.serviceStoreTitle,
        subtitle: labels.serviceStoreSubtitle,
        showAsteriksSignInSubTitle: true
    }), /*#__PURE__*/ React.createElement(ServiceStore, null), /*#__PURE__*/ React.createElement(Consents, {
        handleOptInsLoading: handleOptInsLoading
    }), /*#__PURE__*/ React.createElement(ImplicitTermsAndConditionsContainer, null), /*#__PURE__*/ React.createElement(Footer, {
        stepName: StepNames.Shipping,
        nextStepDisabled: false,
        onPrevStep: onPrevStep,
        onNextStep: onNextStep,
        isFirstStep: Object.keys(routes !== null && routes !== void 0 ? routes : {})[0] === StepNames.Shipping
    }), /*#__PURE__*/ React.createElement(ImplicitAccountCreationContainer, null));
};

export { StepShipping };
//# sourceMappingURL=StepShipping.js.map
